<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${serviceSlug}`), disabled: true },
        { title: $t('evocall.active_users.title'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch"/>
      </div>
    </Breadcrumbs>

    <div>
      <div class="row buttonSpace">
        <div class="col-12">
          <TableView
            ref="tableView"
            :service-slug="serviceSlug"
            :querySearch="querySearch"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TableView from './TableView'
import Searchable from '@/components/common/Searchable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_EVOCALL_ACTIVEUSERS } from '@/local-storage/LocalStorageKeys'

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [
    IndexTablesMixin
  ],
  components: {
    TableView,
    Searchable,
    Breadcrumbs
  },
  data () {
    return {
      querySearch: '',
      localStorageKey: TABLE_EVOCALL_ACTIVEUSERS
    }
  }
}
</script>
